import React, { useContext, useState } from 'react';
import { Form } from "react-jsonschema-form-validation";
import { saveBenefitStatus } from '../../../services/userService';
import { SetupDataPageTemplate } from '../../../components/setup-pages/SetupDataPageTemplate';
import { setupData } from '../../../configs/routes';
import { pathRoot, getMultiSelectElements } from '../BenefitStatus';
import { DiseaseGroupContext } from '../../../contexts/diseaseGroupContext';

export function Page2({ benefitStatus, onSaveFailure }) {
	const schema = {
		type: "object"
	};

	const optionsData = [{
		label: "Yes",
		value: true
	}, {
		label: "No",
		value: false
	}];

	const benefitOptionsData = [
		{
			label: "Personal Independant Payments (PIP)",
			value: 0
		},
		{
			label: "Attendance Allowance (AA)",
			value: 1
		},
		{
			label: "Industrial Injuries Disablement Allowance (IIDB)",
			value: 2
		},
		{
			label: "Constant Attendance Allowance (CAA)",
			value: 3
		},
		{
			label: "War Pension",
			value: 4
		},
		{
			label: "A Blue Badge for the car",
			value: 5
		},
		{
			label: "Other",
			value: 6
		},
	]

	const [receivingBenefits, setReceivingBenefits] = useState(benefitStatus.receivingBenefits ?? null);

	const [whichBenefits, setWhichBenefits] = useState(benefitStatus.whichBenefits ?? [])

	const updateUserSettings = () => {
		benefitStatus.receivingBenefits = receivingBenefits;
		if(receivingBenefits === false){
			benefitStatus.whichBenefits = [];
		}
		else{
			benefitStatus.whichBenefits = whichBenefits;
		}
		
	};

	const toggleBenefitType = (value) => {

		if (whichBenefits.some(e => e === value)) {
			setWhichBenefits(whichBenefits.filter(e => e !== value));
		}
		else {
			const temp = [...whichBenefits];
			temp.push(value);
			setWhichBenefits(temp);
		}
	};

	const benefitIsChecked = (value) => {
		return whichBenefits.some(e => e === value);
	}
	
	const isReceivingBenefits = (value) => {
		return receivingBenefits === value;
	}

	const onFinish = () => {
		return new Promise((resolve, reject) => {
			updateUserSettings();
			benefitStatus.complete = true;
			saveBenefitStatus(benefitStatus).then(resolve).catch((error) => onSaveFailure(error));
		});
	};

	const headerDetails = {
		title: "Benefit Status",
		currentPage: 2,
		pageCount: 2
	}

	const {theme} = useContext(DiseaseGroupContext);

	return (<><SetupDataPageTemplate headerDetails={headerDetails} backTo={`${pathRoot}/1`} nextTo={setupData} onClickBack={updateUserSettings} onClickNext={{ func: onFinish, async: true }} hideNext={receivingBenefits === null || (receivingBenefits === true && whichBenefits.length === 0)} nextTextOverride={"Finish"}>

		<Form schema={schema}>
			<p className={"text-lg sm:text-xl font-bold mb-3 sm:mb-6"}>Are you currently receiving additional benefits related to your cancer diagnosis?</p>
			<div>
				{getMultiSelectElements(optionsData, "receivingBenefits", receivingBenefits, setReceivingBenefits, isReceivingBenefits, theme)}
			</div>
			{receivingBenefits === true ? <><p className={"text-lg sm:text-xl font-bold mb-6 mt-6 sm:mt-9"}>Please indicate ALL that apply</p>
				<div>
					{getMultiSelectElements(benefitOptionsData, "whichBenefits", whichBenefits, toggleBenefitType, benefitIsChecked, theme)}
				</div></>
				: null}
		</Form>

	</SetupDataPageTemplate></>);
}
